import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from "react-router-dom";
import { faUser, faShoppingCart, faPhoneAlt, faSignInAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
//global components
import {SignInModal} from "./SignInModal";
//services
import { userService } from '../_services/user.service';
import { cartService } from '../_services/cart.service';
import { formatPrice } from "../_helpers";
//style
import './Topbar.sass';

import Swal from 'sweetalert2/dist/sweetalert2.js'
import classNames from "classnames";

import {
	Form,
	Row,
	Col,
	Button,
	Modal,
  } from "react-bootstrap";

// import 'sweetalert2/src/sweetalert2.scss'

import { Formik, Form as FormikForm, Field } from "formik";
import * as yup from "yup";
import { emailService } from '../_services/email.service';

yup.setLocale({
  mixed: {
    required: "This field is required",
  },
  string: {
    email: "Please enter a valid email",
  },
});

const initialValues = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};

const validationSchema = yup.object().shape({
  oldPassword: yup.string().required(),
  newPassword: yup.string().required(),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword")], "Password do not match")
    .required(),
});

const InputField = (props) => (
  <Field name={props.name}>
    {({ field, meta }) => (
      <Form.Group controlId={props.name}>
        <Form.Label>{props.label}</Form.Label>
        <Form.Control type="password" placeholder={props.label} {...field} />
        {meta.touched && meta.error && (
          <Form.Text className="text-danger">{meta.error}</Form.Text>
        )}
      </Form.Group>
    )}
  </Field>
);


const ChangePasswordForm = (props) => {
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={props.onSubmit}
    >
      <FormikForm>
        <Row>
          <Col xs="12">
            <InputField name="oldPassword" label="Current Password" />
          </Col>
          <Col xs="12">
            <InputField name="newPassword" label="New Password" />
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <InputField name="confirmPassword" label="Confirm New Password" />
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <Button type="submit">Submit</Button>
          </Col>
        </Row>
      </FormikForm>
    </Formik>
  );
};

const FormModal = (props) => {
  const { open, onClose, ...rest } = props;
  return (
    <Modal show={open} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ChangePasswordForm {...rest} />
      </Modal.Body>
    </Modal>
  );
};

class Topbar extends Component {
	constructor(props) {
		super(props);
		const logInUser = JSON.parse(localStorage.getItem('user'));
		this.state = {
			openModal: false,
			logInUser: logInUser,
			cart: []
		}

		this.loginRef = React.createRef();
		this.getUserLogin = this.getUserLogin.bind(this);
		this.removeItem = this.removeItem.bind(this);
		this.handleLogout = this.handleLogout.bind(this);
		this.interval = null;
	}

	toggleModal = () => {
		this.setState({ openModal: !this.state.openModal });
	  };

	removeItem(itemId){

		cartService.getAllCart()
		.then(nonce => {
			console.log('Fetched nonce:', nonce); // Ensure nonce is fetched
			return cartService.removeFromCart(itemId);
		})
		.then(() => {
			// Remove the item from the state after it has been removed from the cart
			this.setState(prevState => ({
				cart: {
				  ...prevState.cart,
				  items: prevState.cart.items.filter(item => item.key !== itemId)
				}
			  }));
			console.log('Item removed from cart');
			Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Item successfully removed from your shopping cart',
                showConfirmButton: false,
                timer: 1500
            })
			this.updateCart();
		})
		.catch(error => {
			console.error('Error removing item:', error);
		});

  }
	
	getUserLogin(check){
		if(check === true){
			const logInUser = JSON.parse(localStorage.getItem('user'));
			this.setState({logInUser})
		}
	}

	// This method will be called whenever the component updates
	componentDidUpdate(prevProps, prevState) {
		const logInUser = JSON.parse(localStorage.getItem('user'));
		if (logInUser && JSON.stringify(logInUser) !== JSON.stringify(prevState.logInUser)) {
			this.setState({ logInUser: logInUser });
		}
	}

	componentDidMount() {
		this.isUnmounted = false;
		// Fetch cart data immediately when the component mounts
		this.updateCart();

		// Start interval to periodically update cart data
		this.interval = setInterval(() => {
			if (sessionStorage.getItem("isCartUpdate")) {
				this.updateCart();
				sessionStorage.removeItem("isCartUpdate");
			}
		}, 1500);

	}

	componentWillUnmount() {
		// Mark as unmounted
		this.isUnmounted = true;
		// Clear interval when the component is unmounted
		clearInterval(this.interval);
	}
	
	updateCart() {
		// Fetch cart data from the server
		cartService.getAllCart()
			.then(cart => {
				// Update component state with the fetched cart data
				this.setState({ cart });
			})
			.catch(error => {
				console.error('Error updating cart:', error);
			});
	}

	getSubTotal (items = []) {
        return items.reduce((acc, item) => {
            const itemQuantity = parseFloat(item.q.toString().split(",").join(""));
            const itemPrice = parseFloat(item.c.toString().split(",").join(""));

            return acc + (itemPrice * itemQuantity);
        }, 0);
    }

	renderMenuItems(items) {
		// return items.map((menuItem, index) => (
		// 	<li className={menuItem.child_items && menuItem.child_items.length > 0 ? "nav-item dropdown" : "nav-item"} key={index}>
		// 		<a className={menuItem.child_items && menuItem.child_items.length > 0 ? "nav-link dropdown-toggle" : "nav-link"} data-toggle={menuItem.child_items && menuItem.child_items.length > 0 && "dropdown"} href={menuItem.url} role="button" aria-haspopup="true" aria-expanded="false">
		// 			<span className="menu-title">{menuItem.title}</span>
		// 		</a>
		// 		{menuItem.child_items && (
		// 			<ul className="dropdown-menu">
		// 				{this.renderMenuItems(menuItem.child_items)}
		// 			</ul>
		// 		)}
		// 	</li>
		// ));
		return items.map((menuitem, i) => {
			const isDropdown = menuitem.child_items && menuitem.child_items.length > 0 ? true : false;
			return (
				<li
				  className={classNames("nav-item", {
					dropdown: isDropdown,
				  })}
				  key={i}
				>
				  <a
					className={classNames("nav-link p-1 px-md-3", {
					  "dropdown-toggle": isDropdown,
					})}
					data-toggle={isDropdown && "dropdown"}
					href={menuitem.url}
					role="button"
					aria-haspopup="true"
					aria-expanded="false"
				  >
					{menuitem.title}
				  </a>
				  {isDropdown && (
					<div
					  className="dropdown-menu"
					  style={{ zIndex: 1030, top:'unset' }}
					>
					  {menuitem.child_items.map((submenu, j) => (
						<a
						  key={j}
						  className="dropdown-item"
						  href={submenu.url}
						>
						  {submenu.title}
						</a>
					  ))}
					</div>
				  )}
				</li>
			  );
		})
	}

	
	decodeHTMLEntities(html) {
		const textarea = document.createElement('textarea');
		textarea.innerHTML = html;
		return textarea.value;
	}
	

	handleLogout() {
        userService.logoutUser()
            .then(result => {
                if (result.success) {
                    // Clear user details from state
                    //this.setState({ user: null });
					this.setState({logInUser: null})
                    console.log('Logout successful!');
					
                } else {
                    console.error(result.error);
                }
            });
    }
	
	render() {
		const {logInUser, cart} = this.state;
		const menu = this.props.menu;
		const navPhone = this.props.navPhone;

		const username = logInUser && logInUser ? logInUser.first_name ? logInUser.first_name : '' : '';


		return (
			<>
			<div className="topbar">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<nav className="navbar navbar-expand-lg p-0 navbar-light bg-light">
								{/* Responsive button trigger for topbar */}
								<button
									className="navbar-toggler border-0 p-0"
									type="button"
									data-toggle="collapse"
									data-target="#topbarContent"
									aria-controls="topbarContent"
									aria-expanded="false"
									aria-label="Toggle navigation"
								>
									<span>
									<small>Topbar Links</small>
									</span>
								</button>
								{/* Begin: topbar left links */}
								<div className="collapse navbar-collapse" id="topbarContent">
									{menu.items && (
										<ul className="nav justify-content-start">
											{this.renderMenuItems(menu.items)}
										</ul>
									)}
								</div>

								<ul className="nav justify-content-end login-cart-section">
									<li className="nav-item d-none d-lg-flex">
										<a href="#!" className="nav-link disabled navbar-text"><FontAwesomeIcon icon={faPhoneAlt} aria-hidden="true"/> Need Help? { navPhone && navPhone.content ? navPhone.content : '(02) 8353 3895'}</a>
									</li>
									{!username ?			
									<li className="nav-item">
										<button data-toggle="modal" data-target="#AccountLogin" className="nav-link bg-transparent border-0 p-2"  onClick={() => this.loginRef.current.loginModal(true)}><FontAwesomeIcon icon={faSignInAlt} className="mr-1" aria-hidden="true"/> Login</button>
									</li>
									:
									<li className="nav-item dropdown">
										<a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/about" role="button" aria-haspopup="true" aria-expanded="false">
											<FontAwesomeIcon icon={faUser} className="mr-1" aria-hidden="true" />
											{username}
										</a>
										<div className="dropdown-menu" style={{ zIndex: 9999, top:'unset'}}>

											{logInUser.email === process.env.REACT_APP_ADMIN_EMAIL &&
												<Link className="dropdown-item" to="/admin/dashboard">Administration</Link>
											}
											<a href="#!" className="dropdown-item" onClick={ this.toggleModal}>Change Password</a>
											<Link className="dropdown-item" to="/user-profile">Edit Profile</Link>
											<Link className="dropdown-item" to="/" onClick={() => this.handleLogout()}>Logout</Link>
										</div>
									</li>
									}
									<li className="nav-item dropdown shopping-cart-link">
										<a href="#!" className="nav-link dropdown-toggle p-2" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
											<FontAwesomeIcon icon={faShoppingCart} className="mr-1" aria-hidden="true" />
											<span className="pt-1">{formatPrice(cart?.totals?.total_items, { isCartPrice: true })}</span>
										</a>
										<div className="dropdown-menu cart-items-widget-dropdown dropdown-menu-right p-3" style={{ zIndex: 9999, top:'unset' }}>
											<h5 className="m-0 my-2">Shopping Cart</h5>
											<div className="widget cart-items-widget-dropdown-container">
												{cart && cart.items && cart.items.map(item => (
													<div className="media border-bottom pt-2" key={item.key}>
														<img 
															width="64" 
															src={item.images[0]?.src || 'https://via.placeholder.com/198x144'} 
															className="img-thumbnail d-block rounded mr-3" 
															alt="..." 
														/>
														<div className="media-body">
															<h5 className="mt-0" onClick={() => window.location = '/product/' + item.id}>
																<a href="#!"><small>{this.decodeHTMLEntities(item.name)}</small></a>
															</h5>
															<p><small><span className="text-primary">{formatPrice(item.prices?.price, { isCartPrice: true })}</span> x {item.quantity}</small></p>
														</div>
														<div className="float-right mt-2 mr-3 text-danger" style={{ cursor: "pointer" }}>
															<FontAwesomeIcon icon={faTimes} onClick={() => this.removeItem(item.key)} />
														</div>
													</div>
												))}
												{cart.items && cart.items.length < 1 &&
													<div><em>Cart is Empty</em></div>
												}
											</div>
											<ul className="list-unstyled mt-2">
												<li className="d-flex justify-content-between align-items-center my-3">
													<span className="mr-2"><small>Subtotal:</small></span>
													<strong className="text-right text-primary">{formatPrice(cart?.totals?.total_items, { isCartPrice: true })}</strong>
												</li>
											</ul>
											<div className="d-flex justify-content-center">
												<a href="#!" className="btn btn-primary btn-sm mt-3 mr-2" onClick={() => window.location = '/cart'}>View Cart</a>
												<a href="#!" className="btn btn-primary btn-sm mt-3" onClick={() => window.location = '/checkout'}>Checkout</a>
											</div>
										</div>
									</li>							
								</ul>				
							</nav>

							
						</div> 

					</div>					
				</div>
				<FormModal
					open={this.state.openModal}
					onClose={this.toggleModal}
					onSubmit={(values) => {
					
						emailService.changePassword(values).then(
						({ message }) => {
							Swal.fire({
							position: "center",
							icon: "success",
							title: "Success",
							html: message,
							showConfirmButton: true,
							});

							this.toggleModal();
						},
						(error) => {
							Swal.fire({
							position: "center",
							icon: "error",
							title: "Error",
							html: error,
							showConfirmButton: true,
							});
						}
						);
					}}
					/>
			</div>
			{/* <!-- Modal Box --> */}
			<SignInModal ref={this.loginRef} handleUser={this.getUserLogin}/>
		</>
		)
	}
}

export default Topbar
